import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { EventosEntity, 
  ParametrosIntegracionEntity,
  ServicioIntegracionHcService 
} from 'src/app/services/servicio-integracion-hc.service';
import { AlertModel } from '../shared/alert/alert.component';

@Component({
  selector: 'app-reporte-integracion-hc',
  templateUrl: './reporte-integracion-hc.component.html',
  styleUrls: ['./reporte-integracion-hc.component.css']
})
export class ReporteIntegracionHcComponent implements OnInit {

  ready: boolean;

  mensajeLoading: string;
  mensajeError: string;

  parametros: ParametrosIntegracionEntity;
  eventos: [EventosEntity];
  fechas: SelectItem[] = [];
  indicesFechas: number[];

  constructor(private activatedRoute: ActivatedRoute,
      private servicioIntegracionHc: ServicioIntegracionHcService
    ) { 
    this.activatedRoute.params.subscribe(params => {
      this.parametros = {
        codigoBaseDatos: params['codigoBaseDatos'],
        uncoParametroSimens: params['uncoParametroSimens'],
        uncoAfiliado: params['uncoAfiliado']
      }
    });
  }

  ngOnInit() {
    this.ready = false;
    this.getEventos();
  }

  async getEventos() {
    const response = await this.servicioIntegracionHc.getEventos(this.parametros);
    this.mensajeLoading = 'Cargando información de eventos históricos...';
    try {
      if (response != null) {
        response.subscribe((resp: any) => {
          this.mensajeLoading = '';
          if(resp.error) {
            this.mensajeError = resp.message;
          } else {
            this.eventos = resp.data;
            if(this.eventos.length) {
              this.fechas = this.eventos.map((evento, index) => ({
                label: evento.contacto.fechaHora,
                value: index
              }));
              this.fechas.sort((el1, el2) => new Date(el2.label).getTime() - new Date(el1.label).getTime());
              this.ready = true;
            } else {
              this.mensajeError = 'No se encontraron eventos al paciente';
            }
          }
        }, (err: HttpErrorResponse) => {
          this.mensajeLoading = '';
          this.mensajeError = 'Error al cargar los eventos historicos del paciente';
          console.log('Error al cargar los eventos historicos del paciente', err);
        });
      }
    } catch (e) {
      this.mensajeError = e;
      console.log(e);
    }
  }

  getNombreCompleto(nombre: any) {
    const { nombre1, nombre2, apellido1, apellido2 } = nombre;
    return `${nombre1} ${nombre2} ${apellido1} ${apellido2}`;
  }

  fechasSeleccion(indeces: number[]) {
    this.indicesFechas = indeces;
  }

  verificarSeleccion(index: number)  {
    if(this.indicesFechas === undefined) {
      return true;
    }
    return this.indicesFechas.findIndex((i) => i === index) >= 0;
  }

  isAvailableHeader() {
    return !this.mensajeLoading && !this.mensajeError;
  }

}
